import { observer } from "mobx-react-lite";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../app/localization/localization";
import { RootStoreContext } from "../app/stores/rootStore";
import InfoMessage from "../components/common/InfoMessage";
import {
  Button
} from "reactstrap";
import LogOutSSO from "../views/LogOutSSO";

const LogoutLayout = () => {
  const rootStore = useContext(RootStoreContext);
  const { logout, user } = rootStore.userStore;
  const [t] = useTranslation(["translation"], translationHookOptions);
  const [isSSOLogout, setisSSOLogout] = useState(false);
  
 
  useEffect(() => {
    if (user && user.logoutUrl){
      setisSSOLogout(true);
    }else if(user){
        logout();
       
    }
  }, [logout,user]);

  return (
    <>
    { isSSOLogout ? (
    <>
    <LogOutSSO />

    </>
    ):(
    <div>
      <InfoMessage icon="fas fa-sign-out-alt fa-3x" message={t("logging_out")} />
    </div>
    )}
    </>
  );
};

export default observer(LogoutLayout);
